// -*- coding: utf-8 -*-
// Generated by scripts/generate_from_specs.py
// ResourceType

export default {
    ACTIVITY: "J45AL9Nb",
    BOOK: "0Et83gje",
    EXERCISE: "WEEETopZ",
    GAME: "9dUN1LWT",
    GUIDE: "204TGB4U",
    LESSON: "xgFjFhrA",
    LESSON_PLAN: "OqyPqhxW",
    MEDIA: "rReY3LOO",
    TEXTBOOK: "LQYjqpA",
    TUTORIAL: "WtHeUU1",
};
